/* Form Folly — storefront behaviour.
   Mirrors the approved design. Everything here is progressive: the Liquid
   renders complete without JS, this layer adds the interactions. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MOBILE = function () { return window.innerWidth <= 1000; };

  /* ---------------------------------------------------------- toast */
  var toastTimer = null;
  function toast(msg) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { if (el) el.remove(); }, 2600);
  }

  /* ------------------------------------------------------ mobile drawer */
  (function () {
    var scrim = null, savedY = 0;
    var drawer = $('.drawer');
    if (!drawer) return;

    function focusables() {
      return $$('a, button, input', drawer).filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      savedY = window.scrollY;
      drawer.hidden = false;
      scrim = document.createElement('div');
      scrim.className = 'drawer-scrim';
      scrim.addEventListener('click', close);
      drawer.parentNode.insertBefore(scrim, drawer);
      document.body.style.overflow = 'hidden';
      var first = focusables()[0];
      if (first) first.focus();
    }
    function close() {
      drawer.hidden = true;
      if (scrim) { scrim.remove(); scrim = null; }
      document.body.style.overflow = '';
      window.scrollTo({ top: savedY, behavior: 'instant' });
      var tog = $('[data-menu-toggle]');
      if (tog) { tog.setAttribute('aria-expanded', 'false'); tog.focus(); }
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-menu-toggle]');
      if (t) {
        var willOpen = drawer.hidden;
        willOpen ? open() : close();
        t.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
      if (e.target.closest('[data-menu-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var els = focusables();
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* ------------------------------------------------------ saved items */
  var WISH_KEY = 'ff-wishlist';
  function wishRead() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function wishWrite(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { }
    wishPaintCount();
  }
  function wishHas(handle) {
    return wishRead().some(function (p) { return p.handle === handle; });
  }
  function wishPaintCount() {
    var n = wishRead().length;
    $$('[data-wish-count]').forEach(function (el) {
      el.textContent = n ? String(n) : '';
      el.hidden = n === 0;
    });
    $$('[data-wish-label]').forEach(function (el) {
      el.textContent = n ? n + (n === 1 ? ' item' : ' items') : 'Empty';
    });
  }
  function wishPaintButtons() {
    $$('[data-wish]').forEach(function (btn) {
      var on = wishHas(btn.getAttribute('data-wish'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var title = btn.getAttribute('data-title') || 'this';
      btn.setAttribute('aria-label', (on ? 'Remove ' + title + ' from saved' : 'Save ' + title + ' for later'));
      var text = btn.querySelector('[data-wish-text]');
      if (text) text.textContent = on ? 'Saved' : 'Save for later';
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wish');
    var list = wishRead();
    var i = list.findIndex(function (p) { return p.handle === handle; });
    if (i > -1) { list.splice(i, 1); toast('Removed from saved'); }
    else {
      list.push({
        handle: handle,
        title: btn.getAttribute('data-title') || handle,
        price: btn.getAttribute('data-price') || '',
        image: btn.getAttribute('data-image') || '',
        url: btn.getAttribute('data-url') || '/products/' + handle,
        variant: btn.getAttribute('data-variant') || ''
      });
      toast('Saved: ' + (btn.getAttribute('data-title') || ''));
    }
    wishWrite(list);
    wishPaintButtons();
    if ($('[data-wishlist-grid]')) renderWishlist();
  });

  function renderWishlist() {
    var grid = $('[data-wishlist-grid]');
    if (!grid) return;
    var empty = $('[data-wishlist-empty]');
    var tools = $('[data-wishlist-tools]');
    var list = wishRead();
    grid.innerHTML = '';
    if (empty) empty.hidden = list.length > 0;
    if (tools) tools.hidden = list.length === 0;
    grid.hidden = list.length === 0;
    list.forEach(function (p) {
      var el = document.createElement('div');
      el.className = 'card';
      el.innerHTML =
        '<a class="card__img" href="' + p.url + '" style="display:block">' +
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="card__title"><span>' + p.title + '</span><span class="card__price">' + p.price + '</span></div>' +
        '<div class="wl-actions">' +
        (p.variant
          ? '<button class="btn" data-wl-add="' + p.variant + '" data-handle="' + p.handle + '">Move to bag</button>'
          : '<a class="btn" href="' + p.url + '">View object</a>') +
        '<button class="remove" data-wl-remove="' + p.handle + '" aria-label="Remove ' + p.title + ' from saved">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" width="17" height="17"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button></div>';
      grid.appendChild(el);
    });
  }

  /* cart line "Save for later": remember it, then drop the line */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-then]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var list = wishRead();
    if (!list.some(function (p) { return p.handle === handle; })) {
      list.push({
        handle: handle,
        title: btn.getAttribute('data-title') || handle,
        price: btn.getAttribute('data-price') || '',
        image: btn.getAttribute('data-image') || '',
        url: btn.getAttribute('data-url') || '/products/' + handle,
        variant: btn.getAttribute('data-variant') || ''
      });
      wishWrite(list);
    }
    window.location.href = btn.getAttribute('data-wish-then');
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wl-remove]');
    if (rm) {
      var h = rm.getAttribute('data-wl-remove');
      wishWrite(wishRead().filter(function (p) { return p.handle !== h; }));
      renderWishlist();
      wishPaintButtons();
      return;
    }
    var add = e.target.closest('[data-wl-add]');
    if (add) {
      var id = add.getAttribute('data-wl-add');
      var handle = add.getAttribute('data-handle');
      add.disabled = true;
      cartAdd(id, 1, {}).then(function () {
        wishWrite(wishRead().filter(function (p) { return p.handle !== handle; }));
        renderWishlist();
        wishPaintButtons();
        toast('Moved to bag');
        paintCartCount();
      }).catch(function () { add.disabled = false; toast('Could not add that one'); });
      return;
    }
    var clr = e.target.closest('[data-wishlist-clear]');
    if (clr) { wishWrite([]); renderWishlist(); wishPaintButtons(); }
  });

  /* ------------------------------------------------------------ cart ajax */
  function cartAdd(id, qty, props) {
    var body = { items: [{ id: Number(id), quantity: qty || 1, properties: props || {} }] };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }
  function paintCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count ? String(c.item_count) : '';
        el.hidden = c.item_count === 0;
      });
    }).catch(function () { });
  }

  /* quick add from a product card */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    cartAdd(id, 1, {}).then(function () {
      toast('Added to bag: ' + (btn.getAttribute('data-title') || ''));
      paintCartCount();
      btn.textContent = 'Added';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
    }).catch(function () {
      btn.textContent = label; btn.disabled = false; toast('Sold out, sorry');
    });
  });

  /* ------------------------------------------------- product gallery */
  (function () {
    var main = $('[data-gallery]');
    if (!main) return;
    var imgs = $$('img', main);
    var dots = $$('.pg-dots span', main);
    var counter = $('.pg-counter', main);
    var thumbs = $$('[data-thumb]');
    var i = 0;
    function go(k) {
      if (!imgs.length) return;
      i = (k + imgs.length) % imgs.length;
      imgs.forEach(function (im, j) { im.classList.toggle('on', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + imgs.length;
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    var sx = null;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (sx === null || imgs.length < 2) return;
      var dx = e.changedTouches[0].clientX - sx;
      sx = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    go(0);
  })();

  /* --------------------------------------------- colourway swatches */
  (function () {
    var wrap = $('[data-swatches]');
    if (!wrap) return;
    var name = $('[data-swatch-name]');
    var idField = $('[data-variant-id]');
    var priceEl = $('[data-product-price]');
    var buyLabel = $('[data-buy-label]');
    var stockLine = $('[data-stock-line]');
    $$('[data-swatch]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-swatch]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (name) name.textContent = btn.getAttribute('data-label') || '';
        if (idField) idField.value = btn.getAttribute('data-variant') || idField.value;
        var money = btn.getAttribute('data-price');
        if (money && priceEl) priceEl.textContent = money;
        if (money && buyLabel) buyLabel.textContent = 'Add to bag — ' + money;
        var avail = btn.getAttribute('data-available') === 'true';
        var form = (document.getElementById('ProductForm') || $('[data-product-form]'));
        if (form) {
          var submit = form.querySelector('button[type=submit]');
          if (submit) {
            submit.disabled = !avail;
            submit.style.opacity = avail ? '' : '.5';
            if (!avail) submit.textContent = 'Sold out';
            else if (money) submit.textContent = 'Add to bag — ' + money;
          }
        }
        var notify = $('[data-notify]');
        if (notify) notify.hidden = avail;
        if (stockLine && !avail) {
          stockLine.innerHTML = '<span class="stock-dot stock-dot--out"></span>Sold out while this colour is re-poured';
        }
      });
    });
  })();

  /* ------------------------------------------------ personalisation */
  (function () {
    var input = $('[data-pers]');
    if (!input) return;
    input.addEventListener('input', function () {
      input.value = input.value.toUpperCase().slice(0, Number(input.getAttribute('maxlength') || 4));
    });
  })();

  /* ------------------------------------------------------- steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.stepper');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = Number(input.getAttribute('min') || 0);
    var next = Number(input.value || 1) + Number(btn.getAttribute('data-step'));
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------- sticky add-to-bag */
  (function () {
    var bar = $('.sticky-add');
    if (!bar) return;
    function sync() {
      bar.classList.toggle('on', MOBILE() && window.scrollY > 520);
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    setInterval(sync, 400);
    sync();
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var form = (document.getElementById('ProductForm') || $('[data-product-form]'));
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  })();

  /* --------------------------------------------------- filter panel */
  (function () {
    var toggle = $('[data-filter-toggle]');
    var panel = $('[data-filter-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    /* Shopify storefront filters are URL-driven — submit on change */
    $$('input', panel).forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  })();

  /* --------------------------------------------------- review sort */
  (function () {
    var list = $('[data-rev-list]');
    if (!list) return;
    var cards = $$('[data-rev]', list);
    var none = $('[data-rev-none]');
    $$('[data-rev-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-rev-sort');
        $$('[data-rev-sort]').forEach(function (b) { b.classList.toggle('on', b === btn); });
        var shown = cards.slice();
        if (mode === 'photo') shown = shown.filter(function (c) { return c.getAttribute('data-photo') === 'true'; });
        if (mode === 'high') shown.sort(function (a, b) { return b.getAttribute('data-stars') - a.getAttribute('data-stars'); });
        if (mode === 'low') shown.sort(function (a, b) { return a.getAttribute('data-stars') - b.getAttribute('data-stars'); });
        if (mode === 'recent') shown.sort(function (a, b) { return a.getAttribute('data-order') - b.getAttribute('data-order'); });
        cards.forEach(function (c) { c.hidden = shown.indexOf(c) < 0; });
        shown.forEach(function (c) { list.appendChild(c); });
        if (none) none.hidden = shown.length > 0;
      });
    });
  })();

  /* ----------------------------------------------------- lightbox */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lightbox]');
    if (btn) {
      var src = btn.getAttribute('data-lightbox');
      var box = document.createElement('div');
      box.className = 'lightbox';
      box.innerHTML = '<img src="' + src + '" alt="Customer photo">' +
        '<button aria-label="Close photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" width="22" height="22"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      box.addEventListener('click', function () { box.remove(); });
      document.body.appendChild(box);
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var b = $('.lightbox'); if (b) b.remove(); }
  });

  /* ------------------------------------------------- search recents */
  (function () {
    var form = $('[data-search-form]');
    var key = 'ff-recent-searches';
    function read() { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
    var wrap = $('[data-recents]');
    if (wrap) {
      var list = read();
      if (!list.length) wrap.hidden = true;
      else {
        list.forEach(function (t) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = t;
          b.addEventListener('click', function () { window.location.href = '/search?q=' + encodeURIComponent(t); });
          wrap.insertBefore(b, wrap.querySelector('[data-recents-clear]'));
        });
      }
    }
    var clear = $('[data-recents-clear]');
    if (clear) clear.addEventListener('click', function () {
      try { localStorage.removeItem(key); } catch (e) { }
      if (wrap) wrap.hidden = true;
    });
    if (form) form.addEventListener('submit', function () {
      var q = form.querySelector('input[name=q]');
      if (!q || !q.value.trim()) return;
      var list = read().filter(function (t) { return t.toLowerCase() !== q.value.trim().toLowerCase(); });
      list.unshift(q.value.trim());
      try { localStorage.setItem(key, JSON.stringify(list.slice(0, 6))); } catch (e) { }
    });
  })();

  /* --------------------------------------- gift wrap (cart attribute) */
  (function () {
    var box = $('[data-giftwrap]');
    if (!box) return;
    var note = $('[data-giftnote]');
    function sync() { if (note) note.hidden = !box.checked; }
    box.addEventListener('change', function () {
      sync();
      var form = box.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
    sync();
  })();

  /* ------------------------------------------------------ hover-swipe
     cycles a card's images while hovered (kept from v1) */
  (function () {
    $$('[data-swipe]').forEach(function (el) {
      var track = el.querySelector('.card__track');
      var dots = $$('.card__dots span', el);
      var n = track ? track.children.length : 0;
      if (n < 2) return;
      var i = 0, timer = null;
      function go(k) {
        i = ((k % n) + n) % n;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      }
      el.addEventListener('mouseenter', function () { timer = setInterval(function () { go(i + 1); }, 1100); });
      el.addEventListener('mouseleave', function () { clearInterval(timer); timer = null; go(0); });
      var sx = null;
      el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (sx === null) return;
        var dx = e.touches[0].clientX - sx;
        if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); sx = e.touches[0].clientX; }
      }, { passive: true });
    });
  })();

  /* ------------------------------------------------------------ boot */
  wishPaintCount();
  wishPaintButtons();
  renderWishlist();
})();
